import { useEffect, useState } from "react";
import { styled } from '@mui/material/styles';
import Dialog from '@mui/material/Dialog';
import DialogTitle from '@mui/material/DialogTitle';
import DialogContent from '@mui/material/DialogContent';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import { GetNumbersOfListings } from "../../../Services/Agent";
import { useTranslation } from "react-i18next";

const BootstrapDialog = styled(Dialog)(({ theme }) => ({
    '& .MuiDialogContent-root': {
        padding: theme.spacing(2),
    },
    '& .MuiDialogActions-root': {
        padding: theme.spacing(1),
    },
}));

const ContactAgent: React.FunctionComponent<{ agent: any }> = (props) => {


    const [numberOfListings, setNumberOfListings] = useState<number>();
    const { t } = useTranslation();

    useEffect(() => {
        GetNumbersOfListings(props.agent.emailAddresses).then(resp => {
            setNumberOfListings(resp)
        }).catch(error => {
            console.log("error")
        })
    }, [])

    const [isOpen, setIsOpen] = useState<boolean>(false);

    return (
        <>
            <div className="back-FFFFFF border-20  padd-20 mb-4">
                <div className="d-flex justify-content-start align-items-center mb-4">
                    <div className="marg-right-16" >
                        <img src={props.agent && props.agent.photo && props.agent.photo.src ? props.agent.photo.src : "https://www.transparentpng.com/download/user/gray-user-profile-icon-png-fP8Q1P.png"} className="image-agent" />
                    </div>
                    <div className="">
                        <h5 className="title-18  text-end bold-700 color-black">{props.agent && props.agent.name}  {props.agent && props.agent.familyName}</h5>
                        <button className="button-contact padd-00 reoder back-trans border-trans" onClick={() => setIsOpen(true)}>{t("listingCreation.contact")}</button>
                    </div>
                </div>
                <div className="d-flex ">
                    <div className="col-1">
                        <p className="title-18 bold-500 color-black">{t("listingCreation.totalListing")}</p>
                    </div>
                    <div className="col-1">
                        <p className="title-18 bold-700 color-4F52C1">{numberOfListings ? numberOfListings : 0}</p>
                    </div>
                </div>
                <div className="d-flex ">
                    <div className="col-1">
                        <p className="title-18 bold-500 color-black">{t("listingCreation.languages")}</p>
                    </div>
                    <div className="col-1">
                        <p className="title-18 bold-700 color-4F52C1"> {props.agent.langs.length > 0 ? props.agent.langs.map((s: any) => s.charAt(0).toUpperCase() + s.slice(1)).join(', ') : "English"}</p>
                    </div>
                </div>
            </div>


            <BootstrapDialog
                open={isOpen}
                onClose={() => setIsOpen(false)}
                aria-labelledby="customized-dialog-title"
                fullWidth={true}
                maxWidth="xs"
            >
                <DialogTitle >
                    <div className="para-18 bold-700">{t("listingCreation.agentCard")}</div>
                </DialogTitle>
                <IconButton
                    aria-label="close"
                    onClick={() => setIsOpen(false)}
                    sx={(theme) => ({
                        position: 'absolute',
                        right: 8,
                        top: 8,
                        color: theme.palette.grey[800],
                    })}
                >
                    <CloseIcon />
                </IconButton>
                <DialogContent>
                    <div className="padd-15">
                        <div className="d-flex justify-content-start align-items-center mb-4">
                            <div className="marg-right-16">
                                <img src={(props.agent && props.agent.photo && props.agent.photo.src) ? props.agent.photo.src : "https://www.transparentpng.com/download/user/gray-user-profile-icon-png-fP8Q1P.png"} className="image-agent" style={{ width: "80px", height: "80px" }} />
                            </div>
                            <div className="">
                                <h5 className="title-18  bold-700 color-black">{props.agent && props.agent.name}</h5>
                                <p className="para-16 bold-700 color-746AFF">{numberOfListings ? numberOfListings : 0} {t("navbar.balanceCard.listings")}</p>
                            </div>
                        </div>
                       {props.agent.emailAddresses && <div className="d-flex justify-content-between align-items-center mb-4">
                            <div className="para-16 color-07">{t("qrCode.email")}</div>
                            <div className="para-16 bold-700 color-black">{props.agent && props.agent.emailAddresses}</div>
                        </div>}
                        <div className="d-flex justify-content-between align-items-center mb-4">
                            <div className="para-16 color-07">{t("qrCode.phoneNumber")}</div>
                            <div className="para-16 bold-700 color-black">{props.agent && props.agent.phoneNumbers}</div>
                        </div>
                        <div className="d-flex">
                            <button type="button" className="button-dash back-746AFF color-FFFFFF  border-746AFF padd-15-30 marg-right-16 width-100-100" onClick={() => window.location.href = `tel:${props.agent.phoneNumbers}`}>
                                {t("qrCode.call")}
                            </button>
                            <button type="button" className="button-dash back-746AFF color-FFFFFF  border-746AFF padd-15-30 width-100-100" onClick={() => window.open(`https://wa.me/${props.agent.phoneNumbers}`, "_blank")}>
                                {t("qrCode.whatsApp")}
                            </button>
                        </div>
                    </div>
                </DialogContent>
            </BootstrapDialog>
        </>
    )

}
export default ContactAgent;